module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Darkest-Minds-The.0735e21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Darkest-Minds-The.jpg
// module id = qCeE
// module chunks = 0